<template>
    <v-form v-model="validForm" autocomplete="off" method="post" action="/customer_users">
        <v-card>
            <v-card-title>{{ title }}</v-card-title>
            <v-card-text>
                <CsrfToken />
                <select-item name="customer_id" v-model="data.customer" :errors="field_errors.customer_id"
                    @change="field_errors.customer_id = null" action="/customers/list" item-value="id" item-text="name"
                    label="Cliente" required prepend-icon="domain" />

                <v-text-field name="name" v-model="data.name" :error-messages="field_errors.name"
                    @change="field_errors.name = null" label="Username" type="text" required :rules="rules.name"
                    prepend-icon="account_box" autocomplete="off" />

                <v-text-field name="email" v-model="data.email" :error-messages="field_errors.email"
                    @change="field_errors.email = null" label="E-mail" type="email" required :rules="rules.email"
                    prepend-icon="email" autocomplete="off" />

                <v-text-field name="password" v-model="data.password" :error-messages="field_errors.password"
                    @change="field_errors.password = null" label="Password" clearable :rules="rules.password"
                    prepend-icon="password" autocomplete="off" :type="showPwd ? 'text' : 'password'"
                    :append-icon="!showPwd ? 'visibility' : 'visibility_off'" @click:append="showPwd = !showPwd" />
                <a @click="generatePassword">Genera password casuale</a>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn type="submit" color="primary" :disabled="!canSubmit">
                    <v-icon left>send</v-icon>
                    {{ isNew ? 'Crea' : 'Salva' }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<script>
import { Vuelidator, Rule } from '../Vuelidator/index.js';

export default {
    props: {
        value: { type: Object, },
        fieldErrors: { type: Array },
    },
    data() {
        const validator = new Vuelidator({
            name: [Rule.required(), Rule.string(), Rule.min(3)],
            email: [Rule.required(), Rule.min(3)],// Rule.email(),
            password: [Rule.required(), Rule.string(), Rule.min(3)],
            customer_id: [Rule.required(),],
        });
        const rules = validator.getRules();

        const data = Object.assign({
            id: null,
            name: '',
            email: '',
            password: '',
            customer_id: null,
            customer: null,
        }, this.value || {});

        const field_errors = Object.assign({
            name: null,
            email: null,
            password: null,
            customer_id: null,
        }, this.fieldErrors || {});

        return {
            data,
            field_errors,
            rules,

            validForm: false,
            loading: false,
            error: null,
            showPwd: false,
        };
    },
    computed: {
        canSubmit() { return this.validForm; },
        isNew() { return this.data.id === null },
        title() {
            return this.isNew ? 'Nuovo accesso cliente' : 'Modifica  accesso cliente';
        },

    },
    methods: {
        generatePassword(){
            this.data.password = Math.random().toString(36).substring(2, 10) ;
            this.showPwd = true;
        }
    },
    watch: {
        'data.customer': function () {
            this.data.customer_id = this.data.customer?.id;
            if (this.data.customer?.email)
                this.data.email = this.data.customer?.email;
            if (this.data.customer?.referent)
                this.data.name = this.data.customer?.referent;
        },
    },

}
</script>